var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 4L16.5116 4.51958V19.5951L16.6646 19.7477L23.6623 15.6113L16.6646 4Z",
    fill: "#C0CCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 4L9.66663 15.6113L16.6646 19.7477V12.4305V4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6645 21.0727L16.5782 21.1778V26.5479L16.6645 26.7996L23.6665 16.9384L16.6645 21.0727Z",
    fill: "#C0CCF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 26.7996V21.0727L9.66663 16.9384L16.6646 26.7996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6647 19.7478L23.6624 15.6114L16.6647 12.4305V19.7478Z",
    fill: "#8198EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66663 15.6114L16.6646 19.7478V12.4305L9.66663 15.6114Z",
    fill: "#C0CCF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.58db1b713136b60de982da79b84d3adc.svg";
export { ForwardRef as ReactComponent };